module.exports = __webpack_public_path__ + "static/Bitmap-cdf3a187c342921aed38058ba86ea2d7.svg";